import PersonalTab from "./PersonalTab";

export default PersonalTab;
